import React from 'react';
import { formatTime, formatPathLabel, downloadJSON } from '../utils';
import { JsonDiffView } from './JsonDiffView';

interface OcrPanelProps {
  title: string;
  subtitle: string;
  data: any;
  rawData: any;
  error?: string;
  timings: { label: string; value?: number; variant?: string }[];
  fileName: string;
  serviceName: string;
  diffPaths?: Set<string>;
  missingPaths?: Set<string>;
  otherServiceName?: string;
}

export function OcrPanel({
  title, subtitle, data, rawData, error, timings, fileName, serviceName,
  diffPaths, missingPaths, otherServiceName,
}: OcrPanelProps) {
  const getChipClass = (t: { value?: number; variant?: string }) => {
    const classes = ['timing-chip'];
    if (t.variant) classes.push(t.variant);
    if (t.value && t.value > 5000 && t.variant !== 'auth' && t.variant !== 'auth-cached' && t.variant !== 'parse' && t.variant !== 'total') {
      classes.push('slow');
    }
    return classes.join(' ');
  };

  return (
    <div className="ocr-panel">
      {/* Panel Head */}
      <div className="panel-head">
        <div className="panel-name-group">
          <span className="panel-name">{title}</span>
          <span className="panel-subtitle">{subtitle}</span>
        </div>
        <span className={`panel-status-badge ${error ? 'error' : 'success'}`}>
          {error ? 'Error' : 'Success'}
        </span>
      </div>

      {/* Timing Badges */}
      <div className="timing-badges">
        {timings.map(t => (
          <div key={t.label} className={getChipClass(t)}>
            <span className="timing-label">{t.label}</span>
            <span className="timing-value">{formatTime(t.value)}</span>
          </div>
        ))}
      </div>

      {/* JSON Preview */}
      <span className="json-label">Response Preview</span>
      {error ? (
        <pre className="json-box json-error">{JSON.stringify(data, null, 2)}</pre>
      ) : (
        <pre className="json-box">
          <JsonDiffView data={data} diffPaths={diffPaths ?? new Set()} />
        </pre>
      )}

      {/* Missing Properties */}
      {missingPaths && missingPaths.size > 0 && otherServiceName && (
        <div className="missing-props">
          <span className="missing-label">Chybejici oproti {otherServiceName}:</span>
          <div className="missing-chips">
            {Array.from(missingPaths).map(path => (
              <span key={path} className="missing-chip">{formatPathLabel(path)}</span>
            ))}
          </div>
        </div>
      )}

      {/* Raw Response Download */}
      {rawData && (
        <button
          className="btn-ghost"
          onClick={() => downloadJSON(rawData, `${fileName}_${serviceName}_raw.json`)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#30363D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          <span>Raw response</span>
        </button>
      )}
    </div>
  );
}
